// Dictionary domain words
export const FLASH = 'flash';
export const SAAS = 'saas';
export const MERCHANTS = 'merchants';
export const CO2 = 'co2';
// Dictionary platforms and apps
export const CORE_PLATFORMS = [FLASH, SAAS] as const;
export const SIDE_APPS = [MERCHANTS, CO2] as const;
// Node environment values
export const TEST = 'test';
export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
export const TEST_E2E = 'test_e2e';
// Custom test runner environment names
export const UNIT_TEST = 'UNIT_TEST';
// Jest runner environment names
export const JEST_WORKER_ID = 'JEST_WORKER_ID';
// Health constants
export const SELF_OUTBOUND_HEALTH_CHECK = 'self-http-outbound-traffic';
